var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLock = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "inherit",
  className: "lock_svg__svg-safari-fix",
  viewBox: "0 0 24 24",
  "aria-hidden": props["aria-label"] || props["aria-labelledby"] ? undefined : true
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M17.44 8.66h.24c1.8 0 3.26 1.46 3.26 3.26v6.81c0 1.8-1.46 3.26-3.26 3.26H6.35a3.26 3.26 0 0 1-3.26-3.26v-6.81c0-1.8 1.46-3.26 3.26-3.26h.23V7.43C6.58 4.44 9.02 2 12.01 2s5.43 2.44 5.43 5.43zM12 4c-1.89 0-3.43 1.54-3.43 3.43v1.23h6.86V7.43C15.43 5.54 13.89 4 12 4m5.67 16c.69 0 1.26-.56 1.26-1.26v-6.81c0-.69-.56-1.26-1.26-1.26H6.34c-.69 0-1.26.56-1.26 1.26v6.81c0 .69.56 1.26 1.26 1.26zM9 15.33c0-1.65 1.35-3 3-3s3 1.35 3 3-1.34 3-3 3-3-1.35-3-3m2 0c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1",
  clipRule: "evenodd"
})));
export default SvgLock;